<template>
  <div class="footer-buttons">
    <rate-limit-counter
      v-if="shouldShowRateCounterCircle"
      variation="flashcard-v2"
      class="right-margin"
    />
    <share-button
      :flashcard="flashcard"
    ></share-button>
    <bookmark-button
      v-if="!isQuiz"
      class="footer-button"
      :flashcard="flashcard"
      :category="category"
    ></bookmark-button>
  </div>
</template>

<script>
import BookmarkButton from '@/components/flashcards-v2/fragments/BookmarkButton.vue';
import DeviceTypeMixin from '@/mixins/deviceType';
import RateLimitCounter from '@/components/singletons/rate-limit-counter.vue';
import RateLimitMixin from '@/mixins/rate-limit';
import ShareButton from '@/components/flashcards-v2/fragments/ShareButton.vue';

export default {
  components: {
    BookmarkButton,
    RateLimitCounter,
    ShareButton,
  },
  mixins: [DeviceTypeMixin, RateLimitMixin],
  props: {
    flashcard: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    shouldShowRateCounterCircle() {
      return this.flashcardIsRateLimited(this.flashcard) && !this.isQotD && this.isPhone;
    },
    isQotD() {
      return this.$route.path.includes('/qotd');
    },
    isQuiz() {
      return this.$route.path.includes('/quizzes');
    },
  },
};
</script>

<style lang="scss" scoped>
  .footer-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: rem-calc(8);

    .right-margin {
      margin-right: rem-calc(8);
    }

    .footer-button {
      height: 28px;
      width: 28px;
      display: grid;
      place-items: center;
      background-color: transparent;
      border: none;
      padding: 0;
    }
  }
</style>
